import React from "react";
import TableBase from "./Base";
import { DateTimeFormat } from "../../helpers/utils";

const AdminsTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	...props
}) => {
	const COLUMNS = [
		{
			title: "Email",
			dataIndex: "email",
			width: 250,
			ellipsis: true,
		},
		{
			title: "Role",
			dataIndex: "role",
			width: 150,
			ellipsis: true,
			render(record) {
				return (
					<span className="text-capitalize">
						{record === "super_admin" ? "Super Admin" : record}
					</span>
				);
			},
		},
		{
			title: "Created At",
			dataIndex: "created_at",
			width: 150,
			ellipsis: true,
			render(record) {
				return DateTimeFormat(record);
			},
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 100,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default AdminsTable;
